module.exports = __webpack_public_path__ + "main/assets/public/scalable-image/logo.178f0c743abf665e.svg";